import React, { useState, useEffect } from 'react';
import { createProduct } from '../../api';
import '../Estoque.css';

function ProductModal({ show, onClose, onSubmit }) {
    const initialFormData = {
        description: '',
        ideal: 0,
        min: 0,
        price: 0,
        qty: 0
    };
    
    const [formData, setFormData] = useState(initialFormData);
    const [error, setError] = useState('');
    const [processing, setProcessing] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (show && e.key === 'Escape') {
                onClose();
            }
        };

        if (show) {
            document.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [show, onClose]);

    // Reset form when modal is closed
    useEffect(() => {
        if (!show) {
            setFormData(initialFormData);
            setError('');
            setSuccessMessage('');
        }
    }, [show]);

    if (!show) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setProcessing(true);
            setError('');
            
            const result = await createProduct(formData);
            onSubmit(result.product);
            setSuccessMessage('Produto criado com sucesso!');
            
            // Reset form data after successful creation
            setFormData(initialFormData);
            
            // Close the modal after 2 seconds
            setTimeout(() => {
                setSuccessMessage('');
                onClose();
            }, 2000);
        } catch (err) {
            setError(err.message || 'Error creating product');
        } finally {
            setProcessing(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2 style={{ color: '#4a90e2', fontSize: '1.5rem', marginBottom: '1.5rem', borderBottom: '2px solid rgba(74, 144, 226, 0.3)', paddingBottom: '0.5rem' }}>Novo Produto</h2>
                <form onSubmit={handleSubmit}>
                    {error && <div className="error-message">{error}</div>}
                    {successMessage && <div className="success-message">{successMessage}</div>}
                    
                    <div className="form-group">
                        <label>Descrição:</label>
                        <input
                            type="text"
                            value={formData.description}
                            onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                            required
                            disabled={processing}
                        />
                    </div>

                    <div className="form-group">
                        <label>Quantidade Ideal:</label>
                        <input
                            type="number"
                            min="0"
                            value={formData.ideal}
                            onChange={(e) => setFormData(prev => ({ ...prev, ideal: parseInt(e.target.value) }))}
                            required
                            disabled={processing}
                        />
                    </div>

                    <div className="form-group">
                        <label>Quantidade Mínima:</label>
                        <input
                            type="number"
                            min="0"
                            value={formData.min}
                            onChange={(e) => setFormData(prev => ({ ...prev, min: parseInt(e.target.value) }))}
                            required
                            disabled={processing}
                        />
                    </div>

                    <div className="form-group">
                        <label>Preço:</label>
                        <input
                            type="text"
                            inputMode="decimal"
                            value={formData.price}
                            onChange={(e) => setFormData(prev => ({ ...prev, price: e.target.value.replace(',', '.') }))}
                            required
                            disabled={processing}
                        />
                    </div>

                    <div className="form-group">
                        <label>Quantidade Inicial:</label>
                        <input
                            type="number"
                            min="0"
                            value={formData.qty}
                            onChange={(e) => setFormData(prev => ({ ...prev, qty: parseInt(e.target.value) }))}
                            required
                            disabled={processing}
                        />
                    </div>

                    <div className="modal-actions">
                        <button 
                            type="submit" 
                            className={`success ${processing ? 'disabled' : ''}`}
                            disabled={processing}
                        >
                            {processing ? 'Processando...' : 'Criar Produto'}
                        </button>
                        <button 
                            type="button" 
                            onClick={onClose} 
                            disabled={processing}
                            style={{ opacity: processing ? 0.6 : 1, cursor: processing ? 'not-allowed' : 'pointer' }}
                        >
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ProductModal; 